/**
 * Message string for when play is interrupted by pause
 * @type {string}
 */
const PLAY_INTERRUPTED_BY_PAUSE_ERROR_MESSAGE: string = 'The play() request was interrupted by a call to pause()';

/**
 * Play function
 * @param media
 * @return {Promise<void>}
 */
export const playMedia = async (media: HTMLMediaElement): Promise<void> => {
  try {
    const promise = media.play();

    if (typeof promise !== 'undefined') {
      await promise;
    }
  } catch (e) {
    if (!(e instanceof Error) || !e.message.includes(PLAY_INTERRUPTED_BY_PAUSE_ERROR_MESSAGE)) {
      throw e;
    }
  }
};


/**
 * Determines if a URL points to a video file based on its extension
 */
export function isVideoUrl(url: string): boolean {
  const VIDEO_EXTENSIONS = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv'];

  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname.toLowerCase();
    const extension = pathname.split('.').pop() ?? '';
    return VIDEO_EXTENSIONS.includes(extension);
  } catch {
    const extension = url.split('.').pop()?.toLowerCase()?.split('?')[0] ?? '';
    return VIDEO_EXTENSIONS.includes(extension);
  }
}